import { Injectable } from '@angular/core';
import { getEnrollmentError } from '@features/redeem-cash-v2/store/selectors/enrollment.selectors';
import { Store } from '@ngrx/store';
import { Enrollment } from '@rd/types/enrollment.type';
import { HttpError } from '@rd/types/http-error.type';
import { isNotNull } from '@rd/utils/isNotNull';
import { filter, map, Observable } from 'rxjs';
import { LoadEnrollments } from '../store/actions/enrollment.actions';
import {
  getEnrollmentLoading,
  getEnrollments,
  getEnrollmentsSuccess,
  getGroupedEnrollments,
} from '../store/selectors/enrollment.selectors';

@Injectable({
  providedIn: 'root',
})
export class EnrollmentFacade {
  constructor(private store: Store) {}

  enrollments$: Observable<Enrollment[]> = this.store.select(getEnrollments);

  enrollmentsWithoutSupplementaryCardHolderType$: Observable<Enrollment[]> =
    this.enrollments$.pipe(
      filter(isNotNull),
      map((enrollments: Enrollment[]) =>
        enrollments.filter(
          ({ cardholderType }: Enrollment) =>
            cardholderType !== 'supplementary',
        ),
      ),
    );

  jointAccountEnrollments$: Observable<Enrollment[]> = this.store.select(
    getGroupedEnrollments,
  );

  loadEnrollmentsError$: Observable<HttpError | null> =
    this.store.select(getEnrollmentError);

  loadEnrollmentsSuccess$: Observable<boolean> = this.store.select(
    getEnrollmentsSuccess,
  );

  loadEnrollmentsLoading$: Observable<boolean> =
    this.store.select(getEnrollmentLoading);

  loadEnrollments(): void {
    this.store.dispatch(new LoadEnrollments());
  }
}
